import React, { Suspense, lazy, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import LoadingSpinner from './components/LoadingSpinner';
import { APP_VERSION } from './version';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
const Dashboard = lazy(() => import('./pages/Dashboard'));
const OrderManagement = lazy(() => import('./pages/OrderManagement'));
const Production = lazy(() => import('./pages/Production'));
const Expenses = lazy(() => import('./pages/Expenses'));
const Reports = lazy(() => import('./pages/Reports'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const BillingManagement = lazy(() => import('./pages/BillingManagement'));

function App() {

  // 🔥 CACHE CLEAN LOGIC
  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion && storedVersion !== APP_VERSION) {
      // Clear storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear cache storage
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }

      // Unregister service workers
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(reg => reg.unregister());
        });
      }

      // Force reload
      window.location.reload(true);
    }

    localStorage.setItem("app_version", APP_VERSION);
  }, []);

  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Navbar />
        <Container className="mt-4">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <Dashboard />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/orders" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <OrderManagement />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/production" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <Production />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/expenses" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <Expenses />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/reports" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <Reports />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/users" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <UserManagement />
                </Suspense>
              </PrivateRoute>
            } />

            <Route path="/billing" element={
              <PrivateRoute>
                <Suspense fallback={<LoadingSpinner />}>
                  <BillingManagement />
                </Suspense>
              </PrivateRoute>
            } />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;